import { graphic } from 'echarts/core';

export type ShapeProps = {
  points: [number, number][];
  r: number | number[];
};

/**
 * 直角折线（带圆角）
 */
const PolylineRadius = graphic.extendShape({
  shape: {
    points: [],
    r: 0,
    percent: 1
  } as ShapeProps,
  // zrender  src/graphic/helper/roundRect.ts
  // eslint-disable-next-line complexity
  buildPath: (ctx: CanvasRenderingContext2D, shape: ShapeProps, closePath: boolean) => {
    // eslint-disable-next-line prefer-const
    let { points = [], r = 0 } = shape;
    if (!points || points.length <= 1) {
      return;
    }

    if (!Array.isArray(r)) {
      r = Array.from(Array(points.length - 1), () => r) as number[];
    }

    // 左上角
    function drawR1(x: number, y: number, radius: number) {
      ctx.lineTo(x, y + radius);
      if (radius !== 0) {
        ctx.arc(x + radius, y + radius, radius, Math.PI, Math.PI * 1.5);
      }
    }
    // 左上角（逆时针）
    function drawR11(x: number, y: number, radius: number) {
      ctx.lineTo(x + radius, y);
      if (radius !== 0) {
        ctx.arc(x + radius, y + radius, radius, -Math.PI / 2, Math.PI, true);
      }
    }
    // 右上角
    function drawR2(x: number, y: number, radius: number) {
      ctx.lineTo(x - radius, y);
      if (radius !== 0) {
        ctx.arc(x - radius, y + radius, radius, -Math.PI / 2, 0);
      }
    }
    // 右上角（逆时针）
    function drawR22(x: number, y: number, radius: number) {
      ctx.lineTo(x, y + radius);
      if (radius !== 0) {
        ctx.arc(x - radius, y + radius, radius, 0, Math.PI * 1.5, true);
      }
    }
    // 右下角
    function drawR3(x: number, y: number, radius: number) {
      ctx.lineTo(x, y - radius);
      if (radius !== 0) {
        ctx.arc(x - radius, y - radius, radius, 0, Math.PI / 2);
      }
    }
    // 右下角（逆时针）
    function drawR33(x: number, y: number, radius: number) {
      ctx.lineTo(x - radius, y);
      if (radius !== 0) {
        ctx.arc(x - radius, y - radius, radius, -Math.PI * 1.5, 0, true);
      }
    }
    // 左下角
    function drawR4(x: number, y: number, radius: number) {
      ctx.lineTo(x + radius, y);
      if (radius !== 0) {
        ctx.arc(x + radius, y - radius, radius, Math.PI / 2, Math.PI);
      }
    }
    // 左下角（逆时针）
    function drawR44(x: number, y: number, radius: number) {
      ctx.lineTo(x, y - radius);
      if (radius !== 0) {
        ctx.arc(x + radius, y - radius, radius, -Math.PI, Math.PI / 2, true);
      }
    }

    ctx.moveTo(points[0][0], points[0][1]);

    for (let i = 1, l = points.length - 1; i < l; i++) {
      const radius = r[i - 1] || 0;

      if (points[i - 1][0] < points[i + 1][0] && points[i - 1][1] > points[i + 1][1]) {
        // 3 1 象限对角
        if (points[i - 1][0] === points[i][0]) {
          drawR1(points[i][0], points[i][1], radius);
        } else {
          drawR33(points[i][0], points[i][1], radius);
        }
      } else if (points[i - 1][0] < points[i + 1][0] && points[i - 1][1] < points[i + 1][1]) {
        // 2 4 象限对角
        if (points[i - 1][0] === points[i][0]) {
          drawR44(points[i][0], points[i][1], radius);
        } else {
          drawR2(points[i][0], points[i][1], radius);
        }
      } else if (points[i - 1][0] > points[i + 1][0] && points[i - 1][1] < points[i + 1][1]) {
        // 1 3 象限对角
        if (points[i - 1][0] === points[i][0]) {
          drawR3(points[i][0], points[i][1], radius);
        } else {
          drawR11(points[i][0], points[i][1], radius);
        }
      } else if (points[i - 1][0] > points[i + 1][0] && points[i - 1][1] > points[i + 1][1]) {
        // 4 2 象限对角
        if (points[i - 1][0] === points[i][0]) {
          drawR22(points[i][0], points[i][1], radius);
        } else {
          drawR4(points[i][0], points[i][1], radius);
        }
      } else {
        ctx.lineTo(points[i][0], points[i][1]);
      }
    }

    ctx.lineTo(points[points.length - 1][0], points[points.length - 1][1]);

    if (closePath) {
      ctx.closePath();
    }

    //
  }
});

export function installCustomShape() {
  graphic.registerShape('dvPolylineRadius', PolylineRadius);
}
